module.exports = __webpack_public_path__ + "static/media/map.7a99ff6f.jpg";